import fontAwesomeKitUrl from '@/assets/fontAwesome/fontAwesome.js?url'
import { useEnv } from '@/shared/config'

export const FONT_AWESOME_KIT_SCRIPT_ID = 'orphex-font-awesome-kit'

/** Load the repo-vendored kit once, only when the shared Icon component is actually rendered. */
export function ensureFontAwesomeKit(): void {
  if (typeof document === 'undefined' || document.querySelector(`#${FONT_AWESOME_KIT_SCRIPT_ID}`)) {
    return
  }

  const script = document.createElement('script')
  script.id = FONT_AWESOME_KIT_SCRIPT_ID
  script.async = false
  if (useEnv().MODE === 'test') script.dataset.source = fontAwesomeKitUrl
  else script.src = fontAwesomeKitUrl
  document.head.append(script)
}
